// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `user-faqs p[data-f-id=pbf] {
  display: none;
}
user-faqs .header {
  flex: 1 0 auto;
  height: 360px;
  max-height: 360px;
  background: #1A237E;
  background: linear-gradient(to right, #0E2A3B 0%, #34306B 100%);
}
@media screen and (max-width: 599px) {
  user-faqs .header {
    height: 240px;
    padding: 16px;
  }
}
user-faqs .header .hero-text h1 {
  color: white;
  font-size: 48px;
  font-weight: 400;
  letter-spacing: 0.01em;
  text-align: center;
  margin-top: 0;
  margin-bottom: 16px;
}
@media screen and (max-width: 599px) {
  user-faqs .header .hero-text h1 {
    font-size: 24px;
  }
}
user-faqs .header .search {
  width: 100%;
  max-width: 640px;
  height: 56px;
  line-height: 56px;
  padding: 18px;
  border-radius: 28px;
  overflow: hidden;
}
user-faqs .header .search input {
  height: 56px;
  padding-left: 16px;
  border: none;
  outline: none;
}
user-faqs .content {
  max-width: 960px;
  width: 100%;
  margin: 0 auto;
}
user-faqs .content .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/main/user-faqs/user-faqs.component.scss","webpack://./src/@fuse/scss/partials/_breakpoints.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;AAFR;AAKI;EACI,cAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,+DAAA;AAHR;ACwBQ;ED1BJ;IAQQ,aAAA;IACA,aAAA;EAFV;AACF;AAKY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAHhB;ACSQ;EDbI;IAUQ,eAAA;EAFlB;AACF;AAMQ;EACI,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AAJZ;AAMY;EACI,YAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAJhB;AASI;EACI,gBAAA;EACA,WAAA;EACA,cAAA;AAPR;AASQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPZ","sourcesContent":["@import \"src/@fuse/scss/partials/breakpoints\";\n\nuser-faqs {\n    p[data-f-id=\"pbf\"] {\n        display: none;\n    }\n\n    .header {\n        flex: 1 0 auto;\n        height: 360px;\n        max-height: 360px;\n        background: #1A237E;\n        background: linear-gradient(to right, #0E2A3B 0%, #34306B 100%);\n\n        @include media-breakpoint('xs') {\n            height: 240px;\n            padding: 16px;\n        }\n\n        .hero-text {\n            h1 {\n                color: white;\n                font-size: 48px;\n                font-weight: 400;\n                letter-spacing: 0.01em;\n                text-align: center;\n                margin-top: 0;\n                margin-bottom: 16px;\n\n                @include media-breakpoint('xs') {\n                    font-size: 24px;\n                }\n            }\n        }\n\n        .search {\n            width: 100%;\n            max-width: 640px;\n            height: 56px;\n            line-height: 56px;\n            padding: 18px;\n            border-radius: 28px;\n            overflow: hidden;\n\n            input {\n                height: 56px;\n                padding-left: 16px;\n                border: none;\n                outline: none;\n            }\n        }\n    }\n\n    .content {\n        max-width: 960px;\n        width: 100%;\n        margin: 0 auto;\n\n        .loading-shade {\n            position: absolute;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            right: 0;\n            background: rgba(0, 0, 0, 0.15);\n            z-index: 1000;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n    }\n}","// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
